import { useMemo, useState } from 'react';
import { assetSrcSet, assetUrl } from '../lib/media';
import Lightbox from './Lightbox';

export default function ImageGallery({ items = [], columnsClass = 'lg:grid-cols-3' }) {
  const [openIndex, setOpenIndex] = useState(-1);
  const [openImageIndex, setOpenImageIndex] = useState(0);

  const galleryItems = useMemo(
    () =>
      items.map((item) => ({
        ...item,
        primaryImage: item.images?.[0],
      })),
    [items],
  );

  const activeItem = openIndex >= 0 ? galleryItems[openIndex] : null;
  const lightboxImages = activeItem
    ? activeItem.images.map((src, index) => ({
        src,
        label: activeItem.title,
        alt: `${activeItem.title} - billede ${index + 1}`,
        caption: activeItem.images.length > 1 ? `${index + 1} af ${activeItem.images.length}` : '',
      }))
    : [];

  return (
    <>
      <div className={`grid gap-4 sm:grid-cols-2 ${columnsClass}`}>
        {galleryItems.map((item, index) => (
          <button
            key={item.slug}
            type="button"
            onClick={() => {
              setOpenIndex(index);
              setOpenImageIndex(0);
            }}
            className="group overflow-hidden border border-brand-gray-200 bg-white text-left transition-transform duration-200 hover:-translate-y-1"
          >
            <div className="relative aspect-[4/3] overflow-hidden bg-brand-gray-100">
              <img
                src={
                  item.title === 'Vinduer og Døre'
                    ? 'https://assets.auxodev.dk/assets/cc07307d-38f2-4d7e-9eca-ab76959f9adc/shutterstock-1139360030.jpg'
                    : assetUrl(item.primaryImage, 900)
                }
                srcSet={
                  item.title === 'Vinduer og Døre'
                    ? 'https://assets.auxodev.dk/assets/cc07307d-38f2-4d7e-9eca-ab76959f9adc/shutterstock-1139360030.jpg 900w'
                    : assetSrcSet(item.primaryImage, [500, 900, 1200])
                }
                sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
                alt={item.title}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(17,17,17,0.05)_0%,rgba(17,17,17,0.36)_100%)]" aria-hidden="true" />
            </div>

            <div className="p-5">
              <h3 className="font-display text-xl font-bold tracking-tight text-brand-black">
                {item.title}
              </h3>
              {item.description ? <p className="mt-2 text-sm leading-7 text-brand-gray-600">{item.description}</p> : null}
            </div>
          </button>
        ))}
      </div>

      <Lightbox
        open={openIndex >= 0}
        items={lightboxImages}
        startIndex={openImageIndex}
        onClose={() => {
          setOpenIndex(-1);
          setOpenImageIndex(0);
        }}
        onIndexChange={setOpenImageIndex}
      />
    </>
  );
}
